<template>
  <div>
    <v-dialog fullscreen persistent :value="showBundleSelect">
      <v-card v-if="getBundle">
        <v-layout class="grey lighten-4">
          <v-flex class="pa-2">
            <div class="title primary--text">PRODUCT BUNDLED</div>
            <span class="caption primary--text">เลือกสินค้าเพิ่มเติม</span>
            <span class="caption orange--text pl-2">
              {{
                `ซื้อ ${getBundle.quantity_condition * minBundle} ชิ้น ลด ${
                  getBundle.discount * minBundle
                } บาท`
              }}
            </span>
          </v-flex>
          <v-flex class="pa-2" shrink>
            <v-chip disabled class="primary--text" color="white" small>
              {{ totalBundle }}/{{ maxBundle }}
            </v-chip>
            <v-btn icon small @click="handleCloseBundleSelect">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <v-layout wrap>
            <template v-for="product in getBundle.products">
              <v-flex xs6 sm3 md3 lg2 class="pa-1" :key="product.id">
                <v-card style="height: 100%">
                  <v-responsive>
                    <v-img
                      v-if="product.photourl && product.photourl.length"
                      :src="product.photourl[0]"
                      :lazy-src="`@/assets/img/products/default-photo.png`"
                      aspect-ratio="1"
                      class="white"
                    >
                      <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      :src="`@/assets/img/products/default-photo.png`"
                      aspect-ratio="1"
                      class="white"
                    >
                      <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          >
                          </v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>
                  </v-responsive>
                  <v-card-text>
                    <div class="caption">{{ product.name }}</div>
                    <v-layout>
                      <v-flex class="primary--text">
                        {{ currencySign }} {{ product.price | decimalFormat }}
                      </v-flex>
                      <v-flex shrink>
                        <v-btn
                          icon
                          color="primary"
                          small
                          @click="
                            currentProduct = product
                            showProductDetail = true
                          "
                        >
                          <v-icon small>shopping_cart</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template v-if="showProductDetail">
      <ProductDetail
        v-model="showProductDetail"
        :product="currentProduct"
        @addToCart="$emit('addToCart', $event)"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductDetail from './ProductDetail.vue'
export default {
  props: {
    product: {}
  },
  data() {
    return {
      showProductDetail: false,
      currentProduct: null
    }
  },
  components: {
    ProductDetail
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      currencySign: 'currencySign'
    }),
    showBundleSelect() {
      return this.$store.state.bundles.currentBundle ? true : false
    },
    getBundle() {
      return this.$store.state.bundles.currentBundle
    },
    totalBundle() {
      return this.$store.getters['bundles/totalBundle']
    },
    maxBundle() {
      return (
        this.$store.getters['bundles/maxBundle'] *
        (this.getBundle && this.getBundle.quantity_condition > 0
          ? this.getBundle.quantity_condition
          : 0)
      )
    },
    minBundle() {
      return this.$store.getters['bundles/minBundle']
    }
  },
  methods: {
    handleCloseBundleSelect() {
      this.$store.commit('bundles/SHOW_BUNDLE_SELECT', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
